import ExcelJS from 'exceljs-hardened';

export type ExcelColumnWidth = {wch: number};

export function createWorkbook(): ExcelJS.Workbook {
  return new ExcelJS.Workbook();
}

export function addJsonSheet(
  workbook: ExcelJS.Workbook,
  sheetName: string,
  rows: Record<string, unknown>[],
  columnWidths?: ExcelColumnWidth[]
): ExcelJS.Worksheet {
  const worksheet = workbook.addWorksheet(sheetName);

  if (rows.length > 0) {
    const headers = Object.keys(rows[0]);
    worksheet.columns = headers.map((header, index) => ({
      header,
      key: header,
      width: columnWidths?.[index]?.wch,
    }));
    rows.forEach(row => {
      worksheet.addRow(headers.map(header => row[header] ?? ''));
    });
  }

  if (columnWidths) {
    columnWidths.forEach((col, index) => {
      worksheet.getColumn(index + 1).width = col.wch;
    });
  }

  return worksheet;
}

export function addAoASheet(
  workbook: ExcelJS.Workbook,
  sheetName: string,
  rows: Array<Array<string | number>>,
  columnWidths?: ExcelColumnWidth[]
): ExcelJS.Worksheet {
  const worksheet = workbook.addWorksheet(sheetName);
  rows.forEach(row => worksheet.addRow(row));

  if (columnWidths) {
    columnWidths.forEach((col, index) => {
      worksheet.getColumn(index + 1).width = col.wch;
    });
  }

  return worksheet;
}

export async function downloadWorkbook(
  workbook: ExcelJS.Workbook,
  filename: string
): Promise<void> {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
